import { createFileRoute, redirect } from "@tanstack/react-router";

// The rail's settings button lands on the first page.
export const Route = createFileRoute("/_app/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/connections", replace: true });
  },
});
